import { createSlice } from "@reduxjs/toolkit";
import {
  addSongRequest,
  deleteSong,
  getAllCategorySongs,
  getAllSongs,
  getAllTransactions,
  submitSongChoices,
} from "../Actions/songs";
import { toast } from "react-toastify";

const initialState = {
  loading: false,
  songsList: [],
  transactionList: {},
  allCategorySongList: [],
};

const SongSlice = createSlice({
  name: "song",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllSongs.fulfilled, (state, { payload }) => {
      if (payload?.statusCode == 200) {
        state.success = true;
        state.songsList = payload.data;
      } else {
        state.success = false;
        state.error = payload?.message;
      }
    });
    //===========================================================================================

    builder.addCase(getAllCategorySongs.fulfilled, (state, { payload }) => {
      if (payload?.statusCode == 200) {
        state.success = true;
        state.allCategorySongList = payload.data;
      } else {
        state.success = false;
        state.error = payload?.message;
      }
    });

    // ========================================================================

    builder.addCase(addSongRequest.fulfilled, (state, { payload }) => {
      if (payload?.statusCode == 200) {
        state.loading = false;
        toast.success(payload?.message);
      } else {
        toast.error(payload?.message);
        state.loading = false;
      }
    });
    builder.addCase(addSongRequest.pending, (state, { payload }) => {
      state.loading = true;
    });
    builder.addCase(addSongRequest.rejected, (state, { payload }) => {
      state.loading = false;
      toast.error(payload?.message || "Something went wrong");
    });

    // ========================================================================

    builder.addCase(getAllTransactions.fulfilled, (state, { payload }) => {
      if (payload?.statusCode == 200) {
        state.success = true;
        state.transactionList = payload.data;
      } else {
        state.success = false;
        state.error = payload?.message;
      }
    });

    // ========================================================================

    builder
      .addCase(submitSongChoices.pending, (state) => {
        state.loading = true;
        state.submitSuccess = false;
        state.error = null;
      })
      .addCase(submitSongChoices.fulfilled, (state, { payload }) => {
        state.loading = false;

        if (payload?.statusCode === 200) {
          state.submitSuccess = true;
        } else {
          state.submitSuccess = false;
          state.error = payload?.message || "Something went wrong";
        }
      })
      .addCase(submitSongChoices.rejected, (state, { payload }) => {
        state.loading = false;
        state.submitSuccess = false;
        state.error = payload || "Something went wrong";
      });

    // ========================================================================

    builder
      .addCase(deleteSong.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteSong.fulfilled, (state, { payload }) => {
        state.loading = false;

        // if (payload?.statusCode === 200) {
        //   state.songsList = state?.songsList?.filter(
        //     (song) =>
        //       song.id !== payload.deletedId && song._id !== payload.deletedId
        //   );
        // } else {
        //   state.error = payload?.message || "Failed to delete song";
        // }
      })
      .addCase(deleteSong.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload || "Something went wrong";
      });
  },
});

export default SongSlice.reducer;
